var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRandstadWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "none",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10c-6.078 0-11 4.922-11 11s4.922 11 11 11 11-4.922 11-11-4.922-11-11-11zm-2.017 14.85h1.467v-3.995a.821.821 0 00-.217-.566l-2.173-2.354a.7.7 0 00-.523-.235H13.85v1.589h4.033c.608 0 1.1.533 1.1 1.191v4.37m4.034 0H21.55v-3.995c0-.222.081-.423.217-.566l2.173-2.354a.7.7 0 01.522-.235h3.688v1.589h-4.033c-.608 0-1.1.533-1.1 1.191v4.37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 6,
    r: 4,
    fill: "none",
    stroke: "none",
    transform: "translate(5 5)",
    fillOpacity: 0,
    strokeOpacity: 0
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOCIgc3Ryb2tlPSJub25lIiBmaWxsPSJub25lIiBmaWxsLW9wYWNpdHk9IjAiIHN0cm9rZS1vcGFjaXR5PSIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgPHBhdGggZD0iTTIxIDEwYy02LjA3OCAwLTExIDQuOTIyLTExIDExczQuOTIyIDExIDExIDExIDExLTQuOTIyIDExLTExLTQuOTIyLTExLTExLTExem0tMi4wMTcgMTQuODVoMS40Njd2LTMuOTk1YS44MjEuODIxIDAgMCAwLS4yMTctLjU2NmwtMi4xNzMtMi4zNTRhLjcuNyAwIDAgMC0uNTIzLS4yMzVIMTMuODV2MS41ODloNC4wMzNjLjYwOCAwIDEuMS41MzMgMS4xIDEuMTkxdjQuMzdtNC4wMzQgMEgyMS41NXYtMy45OTVjMC0uMjIyLjA4MS0uNDIzLjIxNy0uNTY2bDIuMTczLTIuMzU0YS43LjcgMCAwIDEgLjUyMi0uMjM1aDMuNjg4djEuNTg5aC00LjAzM2MtLjYwOCAwLTEuMS41MzMtMS4xIDEuMTkxdjQuMzciLz4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDUpIiBmaWxsLW9wYWNpdHk9IjAiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLW9wYWNpdHk9IjAiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNyIgY3k9IjYiIHI9IjQiIHN0cm9rZT0ibm9uZSIgZmlsbD0ibm9uZSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgRandstadWhite as ReactComponent };